require('./common.js');
require('./object_fit_images.js');
require('./faq.js');

require('./anime-setAnimation.js');
require('./anime-animeScript.js');
require('./anime-main.js');